import { MOCK_PATIENTS } from '../../constants/mockPatients';

export const NOUR = MOCK_PATIENTS.find((p) => p.id === 'p6');

export const LIST_PATIENTS = [
  MOCK_PATIENTS.find((p) => p.id === 'p1'),
  MOCK_PATIENTS.find((p) => p.id === 'p3'),
  NOUR,
].filter(Boolean);

export const BP_TRANSCRIPT = 'Room 21 Nour Al-Deen, BP 95 over 60, pulse 88.';
export const MAR_TRANSCRIPT =
  'Room 21 Nour Al-Deen, gave Budesonide inhaler 100 micrograms, tolerated well.';

export const SCENE_CAPTIONS = {
  patients: 'Patients — browse your roster',
  favorite: 'Favorite Nour Al-Deen',
  open_patient: 'Open patient details',
  profile: 'Review allergies, diagnoses & meds',
  tasks_pending: 'Pending tasks for this shift',
  manual_done: 'Check off a manual task',
  bp_tap: 'Tap Blood Pressure task',
  bp_record: 'Hold mic — record vitals',
  bp_review: 'Review vitals & save',
  tasks_done: 'Blood Pressure — completed',
  mar_tap: 'Tap medication task',
  mar_record: 'Hold mic — record MAR',
  mar_review: 'Review medication & save',
  tabs: 'Notes, Vitals & Meds tabs',
  handover: 'End shift — generate handover',
};

export const SCENE_DURATIONS = {
  patients: 2200,
  favorite: 1800,
  open_patient: 1600,
  profile: 2800,
  tasks_pending: 2200,
  manual_done: 2000,
  bp_tap: 1400,
  bp_record: 3800,
  bp_review: 2600,
  tasks_done: 2200,
  mar_tap: 1400,
  mar_record: 3800,
  mar_review: 2600,
  tabs: 4800,
  handover: 3200,
};

export const SCENE_ORDER = [
  'patients',
  'favorite',
  'open_patient',
  'profile',
  'tasks_pending',
  'manual_done',
  'bp_tap',
  'bp_record',
  'bp_review',
  'tasks_done',
  'mar_tap',
  'mar_record',
  'mar_review',
  'tabs',
  'handover',
];
